import React, { useEffect, useState } from "react";
import DefaultLayout from "../../layouts/defaultLayout";
import "./style.css";
import BurdCrumbs from "../../components/burdCrumbs";
import TableLayout from "../../components/table";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../../constants";
import { Input } from "../../components/form-elements";
import { Loader } from "rsuite";
import Modal from "../../components/modal";
import { addition } from "../../assets/svgIcons";
import { userData } from "../../data/fake_login_data";
import TextArea from "../../components/form-elements/textarea";
import { perms } from "../../data/side_nav_data";
import { exportToCSV } from "../../functions";
import PageHeader from "../../components/page-header";
import StatsCards from "../../components/stats-cards";
import ShowHideModal from "../../components/show-hide-modal";
import ButtonsState from "../../components/buttons-state";
const Chains = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchHeaderKet, setSearchHeaderKey] = useState("");
  const [showAdd, setShowAdd] = useState(false);
  const [chainName, setChainName] = useState(false);
  const [orderNumber, setOrderNumber] = useState(null);
  const [chainLogo, setChainLogo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);
  const [materialData, setMaterialData] = useState({});
  const [material_id, set_material_id] = useState(null);
  const [loader, setLoader] = useState(false);
  const [hiddenId, setHiddenId] = useState(false);
  const [gradeName, setGradeName] = useState(false);
  const [deleteId, setDeleteId] = useState(false);
  const [editId, setEditId] = useState(false);
  const [opened, setOpened] = useState(null);
  const headers = [
    {
      label: "ID",
      dataIndex: "chain_id",
      search: true,
      sort: true,
    },
    // {
    //   label: "Number",
    //   dataIndex: "material_number",
    //   search: true,
    //   sort: true,
    //   type: "children",
    //   children: ({ headers, row }) => {
    //     const handleBlur = async (material_id, material_number) => {
    //       set_material_id(null);
    //       setArrangeNumber(material_id, material_number);
    //     };

    //     const handleFocus = () => {
    //       set_material_id(row?.material_id);
    //     };

    //     const handleClick = () => {
    //       set_material_id(row?.material_id);
    //     };
    //     const newNumber = data?.filter(
    //       (item) => item?.material_id == row?.material_id
    //     )[0]?.material_number;
    //     return (
    //       <div
    //         style={{ width: "fit-content", cursor: "pointer" }}
    //         onClick={handleClick}
    //       >
    //         <input
    //           style={{ width: "120px", cursor: "pointer" }}
    //           type="text"
    //           onChange={(e) =>
    //             setMaterialData({
    //               id: row?.material_id,
    //               number: e.target.value,
    //             })
    //           }
    //           onFocus={() => handleFocus()}
    //           defaultValue={
    //             materialData?.id == row?.material_id
    //               ? materialData?.number
    //               : row?.material_number
    //           }
    //           value={
    //             materialData?.id == row?.material_id
    //               ? materialData?.number
    //               : row?.material_number
    //           }
    //           disabled={loader}
    //           className={
    //             material_id === row?.material_id
    //               ? "MR_input_form_element active"
    //               : "MR_input_form_element lazy"
    //           }
    //           onBlur={async (e) => {
    //             await handleBlur(row?.material_id, e.target.value);
    //           }}
    //         />
    //       </div>
    //     );
    //   },
    // },
    perms?.includes("*3_1") || perms?.startsWith("3_1")
      ? {
        label: "Show Courses",
        type: "children",
        children: ({ headers, row }) => {
          return (
            <div>
              <ButtonsState
                state={"view"}
                onClick={() => {
                  navigate("courses", {
                    state: {
                      chain_id: row?.chain_id,
                      chain_name: row?.chain_name,
                      university_id: location?.state?.university_id,
                      grade_id: location?.state?.grade_id,
                    },
                  })
                }}
              />
            </div>
          );
        },
      }
      : {},
    {
      label: "chain_name",
      dataIndex: "chain_name",
      sort: true,
    },
    {
      label: "chain_Image",
      type: "children",
      children: ({ row }) => {
        return <img src={row?.photo} alt={row?.chain_name} />;
      },
    },
    {
      label: "Current status",
      type: "children",
      children: ({ row }) => {
        if (row.hidden == "yes" || row.hidden == "") {
          return <span className="text-danger textCurrent">InActive</span>;
        } else {
          return <span className="text-success textCurrent">Active</span>;
        }
      },
    },
    perms?.includes("*3_3") || perms?.startsWith("3_3")
      ? {
        label: "Actions",
        type: "children",
        children: ({ headers, row, index, lastIndex }) => {
          return (
            <div className="menu_Open_close">
              <div
                className="open_close"
                style={{ cursor: "pointer", color: "black" }}
                onClick={() => {
                  const currentId = row?.course_subscription_id || row?.chapter_subscription_id || row?.chain_id;
                  setOpened(opened == currentId ? null : currentId);
                }}
              >
                <img
                  src="https://res.cloudinary.com/duovxefh6/image/upload/v1701489400/menu_hrpzcb.png"
                  alt=""
                  style={{ width: "20px", height: "20px" }}
                />
              </div>
              {(row?.course_subscription_id || row?.chapter_subscription_id || row?.chain_id) == opened ? (
                <div
                  className={
                    index == lastIndex - 1 ||
                      index == lastIndex - 2 ||
                      index == lastIndex - 3
                      ? "actions-views row-actions-view"
                      : "actions-views column-actions-view"
                  }
                >
                  {/* <button
                  className="btn btn-danger"
                  style={{ marginRight: "10px" }}
                  onClick={() => {
                    setDeleteId(row);
                  }}
                >
                  Delete
                </button> */}
                  {perms?.includes("*3_3") || perms?.startsWith("3_3") ? (
                    <ButtonsState
                      state={"edit"}
                      onClick={() => {
                        setEditId(row);
                      }}
                    />
                  ) : null}
                  {/* setEditId */}
                </div>
              ) : null}
            </div>
          );
        },
      }
      : {},
    perms?.includes("*3_4") || perms?.startsWith("3_4")
      ? {
        label: "Change status",
        type: "children",
        children: ({ row }) => {
          if (row.hidden !== "yes") {
            return (
              <ButtonsState
                state={"activate"}
                onClick={() => {
                  setHiddenId({
                    chain_id: row?.chain_id,
                    chain_name: row?.chain_name,
                    status: "yes",
                  });
                }}
              />
            )
          } else {
            return (
              <ButtonsState
                state={"deactivate"}
                onClick={() => {
                  setHiddenId({
                    chain_id: row?.chain_id,
                    chain_name: row?.chain_name,
                    status: "no",
                  });
                }}
              />
            );
          }
        },
      }
      : {},
  ];
  window.addEventListener("click", (e) => {
    if (
      opened &&
      !e.target?.classList?.contains("actions-views") &&
      !e.target?.parentNode?.classList?.contains("open_close")
    ) {
      setOpened(null);
    }
  });
  const addChain = async (e) => {
    e.preventDefault();
    setLoading(true);
    const form = e.target;
    const formData = new FormData();
    try {
      if (chainLogo) formData.append("image", chainLogo?.files[0]);
      const imageUpload = await axios.post(
        BASE_URL + "item_img_uploader.php",
        formData,
        {
          "Content-Type": "Content-Type: multipart/form-data",
        }
      );
      if (imageUpload?.data?.status == "success" && chainLogo) {
        const response = await axios.post(
          BASE_URL + "courses/chains/insert_chain.php",
          {
            chain_name: chainName?.value,
            university_id: location?.state?.university_id,
            photo: imageUpload?.data?.message,
            admin_id: userData?.user_id,
            access_token: userData?.access_token,
            orderNumber: orderNumber?.value,
            grade_id: location?.state?.grade_id,
          }
        );

        if (response.data?.status == "success") {
          toast.success(response.data?.message);
          fetchData();
          setShowAdd(false);
          form.reset();
          setLoading(false);
        } else {
          setLoading(false);
          toast.error(response.data?.message);
        }
      } else {
        setChainLogo(false);
        toast.error("Failed on Upload Image");
        setLoading(false);
      }
    } catch (err) {
      toast.error(err?.message);
      setLoading(false);
    }
  };
  const setArrangeNumber = async (material_id, material_number) => {
    setLoader(true);
    await axios
      .post(BASE_URL + "content/update_video_num.php", {
        chain_id: material_id,
        number: material_number,
        admin_id: userData?.user_id,
        access_token: userData?.access_token,
      })
      .then(async (response) => {
        toast.info(response?.data?.message);
        await fetchData();
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setLoader(false);
      });
  };
  const fetchData = async () => {
    try {
      const response = await axios.post(
        BASE_URL + "courses/chains/select_chain.php",
        {
          university_id: location?.state?.university_id,
          grade_id: location?.state?.grade_id,
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
        }
      );

      setData(response?.data?.message);
    } catch (err) {
      setData([]);
      toast.error(err?.message);
    }
  };

  const hideUniv = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        BASE_URL + "courses/chains/show_hide_chain.php",
        {
          grade_id: location?.state?.grade_id,
          chain_id: hiddenId?.chain_id,
          hidden: hiddenId?.status,
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
          university_id: location?.state?.university_id,
        }
      );
      if (response.data?.status == "success") {
        toast.success(response.data?.message);
        fetchData();
        setHiddenId(false);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(response.data?.message);
      }

      // setShowAdd(false);
    } catch (err) {
      toast.error(err?.message);
      setLoading(false);
    }
  };
  const editChain = async (e) => {
    e.preventDefault();
    setLoading(true);
    const form = e.target;
    const formData = new FormData();
    formData.append("image", chainLogo);
    try {
      const imageUpload = await axios.post(
        BASE_URL + "item_img_uploader.php",
        formData
      );
      if (
        imageUpload?.data?.status == "success" ||
        !chainLogo ||
        editId?.chain_photo
      ) {
        const response = await axios.post(
          BASE_URL + "courses/chains/update_chain.php",
          {
            chain_id: editId?.chain_id,
            photo:
              imageUpload?.data?.message &&
                imageUpload?.data?.message?.length &&
                chainLogo
                ? imageUpload?.data?.message
                : editId?.photo,
            chain_name: chainName ? chainName : editId?.chain_name,
            admin_id: userData?.user_id,
            access_token: userData?.access_token,
          }
        );
        if (response.data?.status == "success") {
          fetchData();
          setEditId(false);
          setChainLogo(null);
          setChainName(null);
          form.reset();
          setLoading(false);
          toast.success(response.data?.message);
        } else {
          setLoading(false);
          toast.error(response.data?.message);
        }
      } else {
        setChainLogo(false);
        toast.error("Failed on Upload Image");
        setLoading(false);
      }
      // setShowAdd(false);
    } catch (err) {
      toast.error(err?.message);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  if (!location?.state?.university_id) {
    navigate(-1);
  }

  return (
    <div id="home">
      <DefaultLayout
        setSearchHeaderKey={setSearchHeaderKey}
        children={
          <div className="childs">

            <PageHeader
              title="Chains"
              description="Manage grade information and settings"
              exportButton={
                perms?.includes("*17_4") || perms?.startsWith("17_4")
                  ? true
                  : false
              }
              deleteButton={
                perms?.includes("*3_2") || perms?.startsWith("3_2")
                  ? true
                  : false
              }
              addButton="Add Chain"
              data={data}
              setShowAdd={setShowAdd}
              addition={
                perms?.includes("*3_2") || perms?.startsWith("3_2")
                  ? addition
                  : null
              }
            />
            <StatsCards data={data} title="Chains" icon={addition} />


            {/* <h4 className="customBreadCrumbs">
              <span>Chains For Grade ({location.state?.grade_name})</span>
              {perms?.includes("*3_2") || perms?.startsWith("3_2") ? (
                <button
                  className="btn btn-primary"
                  onClick={() => setShowAdd(true)}
                >
                  <span>{addition}</span>
                  <span>Add Chain</span>
                </button>
              ) : null}
            </h4>
            {(perms?.includes("*17_4") || perms?.startsWith("17_4")) &&
            data?.length ? (
              <button
                className="btn btn-primary exportBtn"
                onClick={() => {
                  exportToCSV(
                    data,
                    location?.state?.grade_name + " - Chains Data"
                  );
                }}
              >
                Export
              </button>
            ) : null} */}
            <TableLayout
              searchHeaderKet={searchHeaderKet}
              headers={headers}
              data={data}
            />
          </div>
        }
      />
      <Modal
        headerTitle={"Add Chain"}
        open={showAdd}
        toggle={setShowAdd}
        children={
          <form
            action="#"
            onSubmit={!loading ? addChain : (e) => e.preventDefault()}
          >
            <div className="inputField">
              <label htmlFor="chain_name">Chain Name</label>
              <Input
                type={"text"}
                id={"chain_name"}
                name={"chain_name"}
                onChange={setChainName}
              />
            </div>
            <div className="inputField">
              <label htmlFor="chain_number">Chain Number</label>
              <Input
                type={"text"}
                id={"chain_number"}
                name={"chain_number"}
                onChange={setOrderNumber}
              />
            </div>
            <div className="inputField">
              <label htmlFor="chain_Logo">Chain Logo</label>
              <Input
                type={"file"}
                id={"chain_Logo"}
                name={"chain_Logo"}
                onChange={(e) => setChainLogo(e)}
                showImage={true}
              />
            </div>

            <button className="btn btn-success">
              {!loading ? "Save" : <Loader />}
            </button>
          </form>
        }
      />
      <Modal
        open={hiddenId}
        toggle={setHiddenId}
        headerTitle={"Show / Hide Chain"}
        children={
          <ShowHideModal
            loading={loading}
            hiddenId={hiddenId}
            setHiddenId={setHiddenId}
            hideUniv={hideUniv}
            title="Chain"
            hidden={hiddenId?.status === "yes" ? true : false}
          />
        }
      />
      <Modal
        headerTitle={"Edit Chain"}
        open={editId}
        toggle={setEditId}
        children={
          <form
            action="#"
            onSubmit={!loading ? editChain : (e) => e.preventDefault()}
          >
            <div className="inputField">
              <label htmlFor="chain_name">Chain Name</label>
              <Input
                type={"text"}
                id={"chain_name"}
                name={"chain_name"}
                defaultValue={editId?.chain_name}
                onChange={(e) => setChainName(e.value)}
              />
            </div>

            <div className="inputField">
              <label htmlFor="chain_Logo">Chain Logo</label>
              <Input
                type={"file"}
                id={"chain_Logo"}
                name={"chain_Logo"}
                onChange={(e) => setChainLogo(e.files[0])}
                showImage={true}
              />
            </div>

            <button className="btn btn-success">
              {loading ? <Loader /> : "Save"}
            </button>
          </form>
        }
      />
    </div>
  );
};

export default Chains;
